<script setup>
/* eslint-disable */
import { onMounted, ref, computed } from "vue";
import { openModal } from '@kolirt/vue-modal';
import { useLaternaStore } from '@/stores/laterna';
import _ from 'lodash';
import { useCustomerStore } from '@/stores/customer';
import Login from '@/components/modals/Login.vue';
import Register from '@/components/modals/Register.vue';
import VerificationEmail from '@/components/modals/VerificationEmail.vue';
import GameOverlayModal from '@/components/casino_v2/game/GameOverlayModal.vue';
import { useGeneralStore } from '@/stores/general';
import { useInitializeStore } from '@/stores/initialize';
import { useDragScroll } from '@/composables/useDragScroll'

import { useRouter } from 'vue-router';
const router = useRouter();
const customerStore = useCustomerStore();
const initializeStore = useInitializeStore();
const generalStore = useGeneralStore();

const games = ref([]);

const props = defineProps({
	section: {
		type: Object,
		required: true,
	},
})

const slider = ref(null)
useDragScroll(slider, {
    speed: 1.5
})


const goToCasino = () => {
    router.push({ path: props.section.navigation_url });
}

// Show Register Modal
const showRegisterModal = () => {
	openModal(Register).then((data) => {
		if (data.show_login) showLoginModal();
	}).catch(() => { });
};

// Show Login Modal
const showLoginModal = () => {
	openModal(Login).then((data) => {
		if (data.show_register) showRegisterModal();
	}).catch(() => { });
};

// Show Verification Mail Modal
const showVerificationEmailModal = () => {
	openModal(VerificationEmail).catch(() => { });
};

const goToGame = (game, demo = false) => {
	var game_id = null;
	if (generalStore.isLicenseEnabled == 'true') game_id = game.id;
	else game_id = game.game_id;

	let params = {
		game_id: game_id,
	};

	if (demo) {
		params.demo = 'demo';
	}

	let router_object = { name: 'casino-game', params: params };

	// Check if Customer is logged in
	if (!customerStore.isLoggedIn) {
		useCustomerStore().redirect_after_login = router_object;

		showLoginModal();

		return;
	}

	// Check if Customer has verified email
	if (!customerStore.hasVerifiedEmail) {
		showVerificationEmailModal();

		return;
	}

	// Go to Game's view
	router.push(router_object);
}

onMounted(async () => {
    games.value = await useLaternaStore().fetchLandingSectionItems(props.section.id)
})

const sortedGames = computed(() => {
	return _.orderBy(games.value, 'sort', 'asc');
});

</script>
<template>
<div class="casino-games">
<div class="container-sm">

    <div class="popular-games-bar">
        <div class="popular-left">
            <img v-if="props.section.media" :src="props.section.media?.path" class="popular-icon"/>
            <span class="popular-title">{{ props.section.title }}</span>
        </div>

        <div class="popular-right">
            <div class="view-all-desktop">
                <button v-if="props.section.navigation_url" @click="goToCasino" class="view-all-btn">{{ $t('landing.view_all')}}</button>
            </div>
        </div>
    </div>

    <div ref="slider"  draggable="false" class="casino-categories">
        <div v-for="game in sortedGames" :key="game.id" class="category-card bonus" @click="goToGame(game)">
            <img v-if="game.media" :src="game.media.path"/>
            <img v-else :src="game.image_url"/>
        </div>
    </div>

    <!-- <div class="featured-bottom-mobile">
        <button @click="goToCasino" class="view-all-btn">{{ $t('landing.view_all')}}</button>
    </div> -->

</div>
</div>
</template>
<style scoped>

.popular-left {
    margin-bottom: 5px;
}

.popular-right {
    margin-bottom: 5px;
}
.popular-left img {
    width: 40px;
}
.header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.header h2 {
    font-size: 22px;
    font-weight: 600;
    color: var(--white);
}

.star {
    font-size: 18px;
}
.casino-games {
    background-color: var(--sportsbook-background-container);
}
.casino-categories {
    display: flex;
    gap: 7px;
    overflow-x: auto;
    padding: 20px 0px 20px 0px;
}
.featured-bottom-mobile {
	display:none;
}

.container-sm {
    padding-top: 10px;
    padding-bottom: 20px;
}
.casino-categories::-webkit-scrollbar {
    height: 6px;
}

.casino-categories::-webkit-scrollbar-thumb {
    background: #2c3a48;
    border-radius: 4px;
}

.category-card {
    width: 243px;
    height: 325px;
    border-radius: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.25s
    ease, box-shadow 0.25s
    ease;
}

.category-card img {
    width: 243px;
    height: 325px;
    border-radius: 18px;;
    object-fit: fill;
}

.category-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

/* 🎨 Gradients */

.popular-games-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	/* padding: 14px 20px; */
	/* background: linear-gradient(90deg, #0b1c28 0%, #0e2636 100%); */
    border-bottom: 1px solid var(--secondary);
	color: var(--white);
}

/* Left side */
.popular-left {
	display: flex;
	align-items: center;
	gap: 10px;
}

.popular-icon {
	font-size: 20px;
}

.popular-title {
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

/* Right side */
.popular-right {
	display: flex;
	align-items: center;
	gap: 18px;
}

/* View all button */
.view-all-btn {
	background: transparent;
	color: var(--white);
   border: 1px solid var(--light-gray);
    border-radius: 5px;
	padding: 8px 20px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition:
		background-color 0.25s ease,
		box-shadow 0.25s ease,
		border-color 0.25s ease;
}

.view-all-btn:hover {
	background-color: rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 10px rgba(255, 255, 255, 0.35);
	border-color: var(--white);
}

.view-all-btn:active {
	transform: scale(0.97);
}

@media screen and (min-width: 300px) and (max-width: 767px) {

    .category-card {
        width: 122px;
        height: 163px;
        border-radius: 18px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.25s
        ease, box-shadow 0.25s
        ease;
    }

    .popular-title {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0.2px;
    }

    .view-all-btn {
        padding: 4px 10px;
        font-size: 12px;
    }

    .category-card img {
        width: 122px;
        height: 163px;
        border-radius: 18px;;
        object-fit: fill;
    }

    .featured-bottom-mobile {
        display: flex;
        justify-content: center;
        margin-top: 12px;
    }


    .popular-left img {
        width: 25px;
    }

    /* Left side */
.popular-left {
	gap: 3px;
}


}




</style>